<template>
  <el-drawer v-model="drawerVisible" :class="Class" :close-on-click-modal="CloseOnClickModal" :size="Size"
             :with-header="false" class="Drawer" close-on-press-escape destroy-on-close
             modal-class="menuModal" @closed="closed" @open="open">
    <div v-if="Items && Items.length >0" class="siderbar">
      <div :class="Items?.length > 0 ? 'close' : 'close notab'" @click="drawerVisible = false">
        <svg-icon icon-class="arrow-double-right"/>
      </div>
      <a v-for="(item, index) in Items" :key="item"
         :class="{ active: currentItem === item.Code || (!currentItem && index === 0) }" @click="scrollTo(item)">
        {{ item.Title }}
      </a>
      <slot name="Siderbar"/>
    </div>
    <el-tooltip v-else :hide-after="0" content="关闭" placement="left">
      <div class="drawer-toggle" @click="drawerVisible = false">
        <svg-icon icon-class="arrow-right"/>
      </div>
    </el-tooltip>
    <div class="wrap">
      <div class="toolbar">
        <div v-if="ShowHeaderBar" class="toolbar-inner">
          <slot name="HeaderBar"/>
        </div>
      </div>
      <div class="content">
        <el-scrollbar v-if="Items && Items.length >0" ref="scrollbarRef" @scroll="scroll">
          <div v-for="item in Items" :id="`draweritem-${item.Code}`" :key="item" :class="item.Code" class="item">
            <div v-if="!item.HideTitle" class="title">
              <div class="title-con">
                <span class="title-text">{{ item.Title }}</span>
                <slot :name="`${item.Code}Oper`"/>
              </div>
            </div>
            <slot :name="`${item.Code}`"/>
          </div>
        </el-scrollbar>
        <slot v-else/>
      </div>
    </div>
  </el-drawer>
</template>

<script lang="ts" setup>
import {computed, ref} from "vue";
import type {ElScrollbar} from "element-plus";

/** 声明事件 */
const emit = defineEmits([
  "update:Visible",
  "update:FormRef",
  "update:Form",
  "DrawerOpen",
  "DrawerOpened",
  "DrawerClosed"
]);
const currentItem = ref("");

const props = defineProps({
  /** 显示抽屉 */
  Visible: {type: Boolean, default: false},
  /** 是否可以通过点击 modal 关闭 Drawer */
  CloseOnClickModal: {type: Boolean, default: true},
  /** 数据项 */
  Size: {type: String, default: "40%"},
  /** 是否显示标题栏 */
  ShowHeaderBar: {type: Boolean, default: true},
  Class: {type: String},
  /** 数据项 */
  Items: {type: Array, default: () => [] as any[]},
});

const scrollbarRef = ref<InstanceType<typeof ElScrollbar>>();
const drawerVisible = computed({
  get: () => props.Visible,
  set: (val) => emit("update:Visible", val)
});

/** 打开抽屉时处理方法 */
const open = () => {
  emit("DrawerOpen");
};

/** 关闭抽屉时处理方法 */
const closed = () => {
  emit("DrawerClosed");
};

/** 滚动事件 */
const scroll = (s: any) => {
  let top = 0;
  (props.Items as [])?.forEach((item: any) => {
    const dom = document.getElementById(`draweritem-${item.Code}`);
    item.Top = top;
    top += dom?.scrollHeight as number;
    // scrollHeight不包含外边距，要加上外边距
    // console.log(scroll.scrollTop, item, top, dom, currentItem);
    if (s)
      if (s.scrollTop >= item.Top && s.scrollTop <= top && !isClick.value) {
        currentItem.value = item.Code;
      }
  });
  isClick.value = false;
};
const isClick = ref(false);
/** 滚动到指定位置 */
const scrollTo = (item: any) => {
  isClick.value = true;
  currentItem.value = item.Code;
  let top = 0;
  (props.Items as []).forEach((pItem: any) => {
    const dom = document.getElementById(`draweritem-${pItem.Code}`);
    pItem.Top = top;
    top += dom?.scrollHeight as number;
    // scrollHeight不包含外边距，要加上外边距
    top += 20;
  });
  // console.log(item.Top);

  scrollbarRef.value!.setScrollTop(item.Top);
};
</script>

<style lang="scss">
.el-splitter-panel {
  overflow: visible !important;
}

.Drawer {
  overflow: visible !important;
  $toolbarHeight: 48px;

  .el-drawer__body {
    overflow: visible;
    padding: 0;
    position: relative;
    $siderbarWidth: 72px;
    height: calc(100% - 2px);

    .drawer-toggle {
      align-items: center;
      background-color: #fff;
      border: 1px solid #e9edf0;
      border-radius: 50%;
      box-sizing: border-box;
      color: #006ad4;
      cursor: pointer;
      display: flex;
      height: 24px;
      justify-content: center;
      left: -12px;
      position: absolute;
      top: 37px;
      width: 24px;
      z-index: 995;
    }

    .drawer-toggle:hover {
      border-color: transparent;
      background-color: #1b9aee;
      color: #fff;
    }

    .wrap {
      width: 100%;
      padding: 0 0 0 24px;
      height: 100%;
      position: relative;

      .toolbar {
        position: absolute;
        height: $toolbarHeight;
        border-bottom: 1px solid #e8e8e8;
        width: calc(100% + 1px - 24px * 2);
        z-index: 99;
        background-color: #fff;
        left: -1px;
        padding: 0 24px;

        &-inner {
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: row;

          > span {
            display: flex;
            align-items: center;
            color: #6e6e6e;
            font-size: 16px;

            svg {
              font-size: 20px;
              margin-right: 5px;
              line-height: 1.5;
              color: rgb(84, 64, 182);
            }
          }

          .right-btn {
            display: flex;

            svg {
              font-size: 20px;
              margin-left: 12px;
              cursor: pointer;
            }
          }
        }
      }

      .content {
        height: calc(100% - #{$toolbarHeight});
        width: 100%;
        padding-top: $toolbarHeight;
        position: relative;

        > .el-scrollbar {
          padding-right: 24px;

          .item {
            margin-bottom: 20px;

            .title {
              // height: 30px;
              margin: 0 0 16px;
              // margin: 0 0 8px;
              // line-height: 24px;
              font-weight: 700;
              font-size: 16px;
              padding-left: 25px;
              padding-right: 25px;
              color: #333333;
              position: relative;
              width: calc(100% - 50px);

              &::before,
              &::after {
                content: "";
                position: absolute;
                top: 50%;
                width: calc(100% - 25px);
                height: 1px;
                background-color: #eee;
              }

              &::before {
                width: 25px;
                left: 0px;
              }

              .title-con {
                // position: absolute;
                position: relative;
                z-index: 1;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .title-text {
                  background: #fff;
                  padding-left: 10px;
                  padding-right: 10px;
                }

                .el-button {
                  float: right;

                  .svg-icon {
                    margin-right: 5px;
                  }
                }

                .el-input {
                  width: auto;
                }
              }
            }
          }
        }

        .el-divider.el-divider--horizontal {
          margin: 20px 0;
        }

        .item:first-child {
          margin-top: 12px;
        }
      }
    }
  }

  .info {
    &-left {
      border-right: 1px solid #e9ebf0;
      padding-bottom: 8px;
      padding-right: 24px;
      padding-top: 18px;
      width: 70%;
    }

    &-right {
      width: 30px;
      padding: 18px 24px 8px;
    }
  }

  .info:not(svg) {
    display: flex;
    justify-content: space-between;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
  }

  .siderbar {
    $siderbarWidth: 100px;
    left: 0 - $siderbarWidth + 1px;
    position: absolute;
    top: 0;
    width: $siderbarWidth;
    background: #fff;
    transform: translateX(-1px);
    box-shadow: -10px 0 16px rgba(0, 0, 0, 0.08);
    border-radius: 4px 0 0 4px;
    border-right: 1px solid #e8e8e8;
    z-index: 10;

    .close {
      text-align: center;
      height: $toolbarHeight;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-bottom: 20px;
      // color: #1b9aee;
      color: $ThemeColor;

      &.notab {
        margin-bottom: 0px;
      }
    }

    a {
      cursor: pointer;
      line-height: 22px;
      text-align: left;
      display: block;
      height: 36px;
      font-size: 14px;
      color: #6e6e6e;
      text-decoration: none;
      padding-left: 15px;
    }

    a.active {
      font-weight: 700;
      color: #3a3c4b;
    }
  }
}
</style>